import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setTitle } from '../../redux/title/action';
import { Spin, Row, Col, Button, Divider } from 'antd';
import { RenderForm } from '../../components/forms';
import { useForm } from 'react-hook-form';
import { useVerifyQRCode } from '../registration-qr/hooks/useGetBarcodeQuery';
import { FORM_QR_CODE } from '../registration-qr/form';
import { TextSmall, TextCustom } from '../../components/text';
import {
  InfoHeaderStyledContainer,
  RegisterStyledContainer,
} from '../../components/container/styles';
import { qrScanButtonStyle } from '../registration-qr/styles/styles';
import liff from '@line/liff';
import { FaQrcode } from 'react-icons/fa';
import { openAlert, openLoading, closeLoading } from '../../components/alert/hooks/useAlert';
import { QRScannerModal } from '../registration-qr/modal/QRScannerModal';
import { navigateTo } from '../../utils/navigation';
import { ROUTES_PATH } from '../../resources/routes-name';
import { setRegisterProductData } from '../../redux/registerProduct/action';

export const WarrantyScanQR = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const isWarrantyNumberRequired = queryParams.get('required') !== '0';

  const { control, getValues, setValue } = useForm();
  const { mutate: verifyQRCode, loading: isVerifyingQR } = useVerifyQRCode();
  const dispatch = useDispatch();
  const [isScanning, setIsScanning] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);

  useEffect(() => {
    dispatch(setTitle('ลงทะเบียนรับประกันสินค้า'));
  }, [dispatch]);

  const navigateToProduct = (warrantyCode) => {
    if (warrantyCode) {
      dispatch(setRegisterProductData({ warrantyNumberCode: warrantyCode }));
    }
    setTimeout(() => {
      navigateTo({
        pathname: ROUTES_PATH.ROUTE_REGISTER_PRODUCT.PATH,
        search: warrantyCode ? `?warrantyNumberCode=${warrantyCode}` : undefined,
      });
    }, 500);
  };

  const handleScanQRCode = async () => {
    try {
      if (liff.isInClient() && liff.scanCode) {
        setIsScanning(true);
        openLoading();
        try {
          const result = await liff.scanCode();
          if (result && result.value) {
            let scannedCode = result.value;
            if (scannedCode.includes('http')) {
              const url = new URL(scannedCode);
              const params = url.searchParams;
              scannedCode = params.get('fw') || scannedCode;
            }
            handleQRVerifyAndNavigate(scannedCode);
          }
        } catch (error) {
          console.error('QR Scan Error:', error);
          if (error.message && !error.message.includes('cancel')) {
            openAlert({
              type: 'error',
              message: error?.message || 'เกิดข้อผิดพลาดในการสแกน QR code',
            });
          }
        } finally {
          setIsScanning(false);
          closeLoading();
        }
      } else {
        setShowQRModal(true);
      }
    } catch (error) {
      console.error('LIFF check error:', error);
      setShowQRModal(true);
    }
  };

  const handleQRVerifyAndNavigate = (scannedCode) => {
    verifyQRCode(scannedCode, {
      onSuccess: () => {
        setShowQRModal(false);
        navigateToProduct(scannedCode);
      },
    });
  };

  const handleOnEnterQRCode = (qrCode) => {
    handleQRVerifyAndNavigate(qrCode);
  };

  return (
    <RegisterStyledContainer>
      <Spin spinning={isVerifyingQR}>
        <InfoHeaderStyledContainer>
          <TextSmall
            text={
              <span>
                {isWarrantyNumberRequired
                  ? 'กรุณาสแกน QR Code รับประกันสินค้า'
                  : 'สแกน QR Code รับประกันสินค้า (ถ้ามี)'}
              </span>
            }
            style={{ color: isWarrantyNumberRequired ? 'red' : '#f30404e0' }}
            bold
          />
        </InfoHeaderStyledContainer>

        {isWarrantyNumberRequired ? (
          <>
            <Row style={{ margin: '0 40px 0 40px' }}>
              <Col span={24}>
                <RenderForm
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  forms={FORM_QR_CODE({ onEnter: handleOnEnterQRCode })}
                />
              </Col>
            </Row>
            <Row style={{ margin: '0 10px' }}>
              <Col span={24}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
                  <Divider style={{ flex: 1, margin: 0, minWidth: 0 }} />
                  <TextCustom text="หรือ" bold size="14px" color="grey" style={{ whiteSpace: 'nowrap' }} />
                  <Divider style={{ flex: 1, margin: 0, minWidth: 0 }} />
                </div>
              </Col>
            </Row>
            <Row style={{ margin: 40 }}>
              <Col span={24}>
                <Button
                  icon={<FaQrcode size={36} />}
                  onClick={handleScanQRCode}
                  loading={isScanning}
                  size="large"
                  style={qrScanButtonStyle}
                >
                  สแกน QR Code
                </Button>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row style={{ margin: '16px 40px 0 40px' }}>
              <Col span={24}>
                <RenderForm
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  forms={FORM_QR_CODE({ onEnter: handleOnEnterQRCode, required: false })}
                />
              </Col>
            </Row>
            <Row style={{ margin: '0 40px 10px 40px' }}>
              <Col span={24}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
                  <Divider style={{ flex: 1, margin: 0, minWidth: 0 }} />
                  <TextCustom text="หรือ" bold size="13px" color="grey" style={{ whiteSpace: 'nowrap' }} />
                  <Divider style={{ flex: 1, margin: 0, minWidth: 0 }} />
                </div>
              </Col>
            </Row>
            <Row style={{ margin: '0 40px 20px' }}>
              <Col span={24}>
                <Button
                  icon={<FaQrcode size={20} />}
                  onClick={handleScanQRCode}
                  loading={isScanning}
                  size="middle"
                  style={{
                    width: '100%',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    fontSize: '14px',
                    color: '#555',
                    borderColor: '#d9d9d9',
                  }}
                >
                  สแกน QR Code
                </Button>
              </Col>
            </Row>
            <Row style={{ margin: '30px 0 0 0' }}>
              <Col span={24}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
                  <Divider style={{ flex: 1, margin: 0, minWidth: 0, borderTop: '2px dashed #f30404e0' }} />
                </div>
              </Col>
            </Row>
            <Row style={{ margin: '30px 40px 16px' }}>
              <Col span={24}>
                <div style={{
                  background: '#fff8e1',
                  border: '1px solid #ffe082',
                  borderRadius: '8px',
                  padding: '12px 16px',
                }}>
                  <TextCustom text="ไม่จำเป็นต้องกรอกหรือสแกน QR Code รับประกัน" size="12px" color="#f30404e0" />
                  <TextCustom text="หากบนกล่องสินค้าไม่มี QR Code รับประกันสินค้า" size="12px" color="#f30404e0" />
                  <TextCustom text="สามารถข้ามขั้นตอนนี้ได้เลย" size="14px" color="#f30404e0" bold={true}/>
                </div>
              </Col>
            </Row>
            <Row style={{ margin: '10px 40px 40px' }}>
              <Col span={24}>
                <Button
                  type="primary"
                  size="large"
                  onClick={() => navigateToProduct(null)}
                  style={{
                    width: '100%',
                    height: '64px',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    backgroundColor: '#53CBF3',
                    borderColor: 'rgb(63, 54, 6)',
                    color: '#000',
                    borderRadius: '8px',
                  }}
                >
                  ถัดไป
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Spin>
      <QRScannerModal
        open={showQRModal}
        onClose={() => setShowQRModal(false)}
        onDetected={handleQRVerifyAndNavigate}
      />
    </RegisterStyledContainer>
  );
};
